import { FiArrowDown } from '@react-icons/all-files/fi/FiArrowDown'
import { FiArrowLeft } from '@react-icons/all-files/fi/FiArrowLeft'
import { FiArrowRight } from '@react-icons/all-files/fi/FiArrowRight'
import { FiArrowUp } from '@react-icons/all-files/fi/FiArrowUp'

// previous/next, left/right, up/down

export const IconArrowUp = FiArrowUp
export const IconArrowDown = FiArrowDown
export const IconArrowLeft = FiArrowLeft
export const IconArrowRight = FiArrowRight
